export const fresh = {
  meta: {
    name: 'Fresh'
  },
  layout: {
    content: {
      border: {
        left: '0'
      },
      boxShadow: '0 0 4px rgba(0, 0, 0, .1)'
    }
  },
  sidebar: {
    background: {
      color: '#2e4e49'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 #264944'
    },
    divider: {
      color: '#4a6b65'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',

      badge: {
        backgroundColor: '#4a6b65',
        color: 'var(--color-white)'
      }
    },

    section: {
      heading: {
        color: {
          _: '#66b8a5',
          hover: '#85d1c0',
          active: 'var(--color-white)'
        },
        icon: {
          background: {
            color: {
              active: '#4a6b65'
            }
          },
          color: {
            _: '#66b8a5',
            active: 'var(--color-white)'
          }
        }
      },
      items: {
        border: {
          left: '2px solid #405c58'
        },
        active: {
          item: {
            color: '#66b8a5'
          }
        }
      },
      item: {
        backgroundColor: {
          active: '#4a6b65',
          hover: 'rgba(255,255,255,.03)'
        },
        color: {
          _: '#66b8a5',
          hover: '#85d1c0',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: '#264944'
      },
      name: {
        color: 'var(--color-white)'
      },
      company: {
        color: '#66b8a5'
      },
      trigger: {
        backgroundColor: '#3e7d73',
        color: 'var(--color-white)'
      }
    }
  }
};
